import {useEffect, useMemo, useState} from 'react';
import moment from 'moment';

/**
 * Current time according to the server, updated every 30 seconds. The difference between the clocks of the
 * server and the device is found when the time of the server arrives, so the time elapsed in an open session
 * does not depend on the clock of the device.
 */
export const useServerNow = (serverTime?: string) => {
  const offset = useMemo(
    () => (serverTime ? moment(serverTime).diff(moment()) : 0),
    // The difference is calculated when the server time arrives
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [serverTime]
  );
  const [now, setNow] = useState(() => moment().add(offset, 'milliseconds'));

  useEffect(() => {
    setNow(moment().add(offset, 'milliseconds'));
    const interval = setInterval(() => setNow(moment().add(offset, 'milliseconds')), 30000);
    return () => clearInterval(interval);
  }, [offset]);

  return now;
};
